import axios from 'axios';
import { ensureHttpsUrl, normalizeHttpsUrls } from '../../utils/helpers/url.helpers';

export const STORE_URL = ensureHttpsUrl('https://store.nexlanka.com');

export const wooCommerceApi = axios.create({
  baseURL: `${STORE_URL}/wp-json/nex/v1`,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: false,
  timeout: 15000,
  paramsSerializer: {
    serialize: (params) => new URLSearchParams(params as Record<string, string>).toString(),
  },
});

wooCommerceApi.interceptors.response.use(
  (response) => ({
    ...response,
    data: normalizeHttpsUrls(response.data),
  }),
  (error) => {
    console.error('[wooCommerceApi] Response error', {
      message: error?.message,
      status: error?.response?.status,
      data: error?.response?.data,
    });
    return Promise.reject(error);
  },
);

export default wooCommerceApi;
